import { render, staticRenderFns } from "./CommonDetailsSearch.vue?vue&type=template&id=96d4ec1c&"
import script from "./CommonDetailsSearch.vue?vue&type=script&lang=js&"
export * from "./CommonDetailsSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports